import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.solidIcon.background.active.light(params);

export default light;
